import { useSuggestionsUuidMap } from '~/providers/RootDataProvider';
import type { Suggestions } from '~/types';

interface PopularReportMeta {
  description: string;
  hue: number;
}

export function usePopularReports(): (Suggestions.Suggestion &
  PopularReportMeta)[] {
  const suggestionsMap = useSuggestionsUuidMap();
  const POPULAR_REPORT_META: Record<string, PopularReportMeta> = {
    'd513e568-ad32-44b5-b0c8-1b7d3fbe88a6': {
      description: 'Stores built on Shopify',
      hue: 142,
    },
    'a9e5c921-6753-4dd5-bbf1-d3e781a53414': {
      description: 'Websites running HubSpot',
      hue: 18,
    },
    'f48d9932-2638-426a-9ca8-d84a6b78fd6e': {
      description: 'Sites using Intercom for support',
      hue: 220,
    },
    '7da5a261-bf51-4098-b6d9-1c8e0f813b08': {
      description: 'Stores built on WooCommerce',
      hue: 280,
    },
    'e0da30f9-f622-4c97-93ff-29bdbb135f75': {
      description: 'Sites using Stripe payments',
      hue: 250,
    },
    '26cd9529-de61-4704-9902-6de1a24485a0': {
      description: 'Analytics with Mixpanel',
      hue: 200,
    },
    '862eed5d-4b4d-43d2-9881-5cd62dd2dcf0': {
      description: 'Sites on Magento commerce',
      hue: 24,
    },
    'c54c39a2-a979-4ef6-8ae9-3c1770fac7ee': {
      description: 'Customer engagement on Braze',
      hue: 170,
    },
  };

  return Object.entries(POPULAR_REPORT_META).flatMap(([uuid, meta]) => {
    const suggestion = suggestionsMap.get(uuid);
    if (!suggestion) {
      return [];
    }
    return {
      ...suggestion,
      ...meta,
    };
  });
}
